export const formatValue = (value: number, viewMode: "kWh" | "Euro") =>
	viewMode === "kWh" ? `${value.toFixed(1)}kWh` : formatCurrency(value);

const numberFormatter = new Intl.NumberFormat("fr-FR", {
	style: "currency",
	currency: "EUR",
});

export function formatCurrency(value: number) {
	return numberFormatter.format(value);
}
